import HeadingElement from '../HeadingElement';
import ContentElement from '../ContentElement';
import TextInputElement from '../TextInputElement';
import BooleanElement from '../BooleanElement';
import MarketSelectorElement from '../MarketSelectorElement';
import MultichoiceElement from '../MultichoiceElement';
import FileUploadElement from '../FileUploadElement';
import LocationInputElement from '../LocationInputElement';
import AddonElement from '../AddonElement';

const form = {
  HeadingElement,
  ContentElement,
  TextElement: TextInputElement,
  BooleanElement,
  MarketSelectorElement,
  MultichoiceElement,
  FileUploadElement,
  LocationInput: LocationInputElement,
  AddonElement,
};

export default form;
